import React from 'react';
import {Route, Switch, Redirect} from 'react-router-dom';
import GA from './helpers/ga';

/* layouts */
import NavigationLayout from './layouts/navigation-layout';
import BasicLayout from './layouts/basic-layout';

/* containers */

import TemplateBoardingPage from './containers/template-boarding-page';
// callback / authentication
import AuthBigcommercePage from './containers/auth-bigcommerce-page';
import AuthShopifyPage from './containers/auth-shopify-page';
import CallbackBigcommerceAuthPage from './containers/callback-bigcommerce-auth-page';
import CallbackBigcommerceLoadPage from './containers/callback-bigcommerce-load-page';
import CallbackShopifyPage from './containers/callback-shopify-page';
import CallbackPaymentPage from './containers/callback-payment-page';
import PaymentFailedPage from './containers/callback-payment-page/payment-failed-page';
import PaymentSucessfulPage from './containers/callback-payment-page/payment-successful-page';
// checkouts
import DashboardCheckoutsPage from './containers/dashboard-checkouts-page';
// emails
import DashboardEmailsStatisticsPage from './containers/dashboard-emails-statistics-page';
import DashboardEmailsPage from './containers/dashboard-emails-page';
import DashboardEmailsActivityPage from './containers/dashboard-emails-activity-page';
import DashboardEmailsSettingsPage from './containers/dashboard-emails-settings-page';
// payments
import DashboardPaymentsPage from './containers/dashboard-payments-page';
// new feature
import WhitelabelPage from './containers/whitelabel-page';
import EmailPlusPage from './containers/email-plus-page';
import DashboardFeaturesApiPage from './containers/dashboard-features-api-page';
import DashboardFeaturesMorePage from './containers/dashboard-features-more-page';

const routes = [
	// others
	{
		path: '/', exact: true, loginRequired: false, Layout: BasicLayout, layoutClass: 'narrow', Component: AuthShopifyPage
	},
	{
		path: '/templates/abandoned-cart/setup', exact: true, loginRequired: false, Layout: BasicLayout, layoutClass: 'width-960', Component: TemplateBoardingPage
	},
	// callback / authentication
	{
		path: '/auth/bigcommerce', exact: true, loginRequired: false, Layout: BasicLayout, layoutClass: 'narrow', Component: AuthBigcommercePage
	},
	{
		path: '/auth/shopify', exact: true, loginRequired: false, Layout: BasicLayout, layoutClass: 'narrow', Component: AuthShopifyPage
	},
	{
		path: '/callback/bigcommerce/auth', exact: true, loginRequired: false, Layout: BasicLayout, layoutClass: 'narrow', Component: CallbackBigcommerceAuthPage
	},
	{
		path: '/callback/bigcommerce/load', exact: true, loginRequired: false, Layout: BasicLayout, layoutClass: 'narrow', Component: CallbackBigcommerceLoadPage
	},
	{
		path: '/callback/shopify', exact: true, loginRequired: false, Layout: BasicLayout, layoutClass: 'narrow', Component: CallbackShopifyPage
	},
	{
		path: '/callback/payment', exact: true, loginRequired: false, Layout: BasicLayout, layoutClass: 'narrow', Component: CallbackPaymentPage
	},
	{
		path: '/callback/payment/fail', exact: true, loginRequired: false, Layout: BasicLayout, layoutClass: 'narrow', Component: PaymentFailedPage
	},
	{
		path: '/callback/payment/success', exact: true, loginRequired: false, Layout: BasicLayout, layoutClass: 'narrow', Component: PaymentSucessfulPage
	},
	// checkouts
	{
		path: '/dashboard/checkouts', exact: true, loginRequired: false, Layout: NavigationLayout, layoutClass: 'fill', Component: DashboardCheckoutsPage
	},
	// email section
	{
		path: '/dashboard/emails/statistics', exact: true, loginRequired: false, Layout: NavigationLayout, layoutClass: 'fill', Component: DashboardEmailsStatisticsPage
	},
	{
		path: '/dashboard/emails', exact: true, loginRequired: false, Layout: NavigationLayout, layoutClass: 'fill', Component: DashboardEmailsPage
	},
	{
		path: '/dashboard/emails/activity', exact: true, loginRequired: false, Layout: NavigationLayout, layoutClass: 'fill', Component: DashboardEmailsActivityPage
	},
	{
		path: '/dashboard/emails/settings', exact: true, loginRequired: false, Layout: NavigationLayout, layoutClass: 'fill', Component: DashboardEmailsSettingsPage
	},
	{
		path: '/dashboard/emails/settings/general', exact: true, loginRequired: false, Layout: NavigationLayout, layoutClass: 'fill', Component: DashboardEmailsSettingsPage
	},
	{
		path: '/dashboard/emails/settings/customization/1', exact: true, loginRequired: false, Layout: NavigationLayout, layoutClass: 'fill', Component: DashboardEmailsSettingsPage
	},
	{
		path: '/dashboard/emails/settings/customization/2', exact: true, loginRequired: false, Layout: NavigationLayout, layoutClass: 'fill', Component: DashboardEmailsSettingsPage
	},
	{
		path: '/dashboard/emails/settings/customization/3', exact: true, loginRequired: false, Layout: NavigationLayout, layoutClass: 'fill', Component: DashboardEmailsSettingsPage
	},
	// payment section
	{
		path: '/dashboard/payments', exact: true, loginRequired: false, Layout: NavigationLayout, layoutClass: 'fill', Component: DashboardPaymentsPage
	},
	// new feature section
	{
		path: '/dashboard/whitelabel', exact: true, loginRequired: false, Layout: NavigationLayout, layoutClass: 'fill', Component: WhitelabelPage
	},
	{
		path: '/dashboard/email-plus', exact: true, loginRequired: false, Layout: NavigationLayout, layoutClass: 'fill', Component: EmailPlusPage
	},
	{
		path: '/dashboard/features/api', exact: true, loginRequired: false, Layout: NavigationLayout, layoutClass: 'fill', Component: DashboardFeaturesApiPage
	},
	{
		path: '/dashboard/features/more', exact: true, loginRequired: false, Layout: NavigationLayout, layoutClass: 'fill', Component: DashboardFeaturesMorePage
	}
];

const PrivateRoute = function ({
	component: Component, layout: Layout, layoutClass, ...rest
}) {
	return (
		<Route
			{...rest}
			render={props => (
				isAuthenticated() ? (
					<Layout containerClass={layoutClass}>
						<Component {...props} />
					</Layout>
				) : (
					<Redirect to={{
						pathname: '/',
						state: {from: props.location}
					}}
					/>
				)
			)}
		/>
	);
};

function isAuthenticated() {
	const token = localStorage.getItem('tkn');
	console.log('token', token);
	if (token) {
		return true;
	}

	// reset cached data
	// localStorage.setItem('banks', '');
	// localStorage.setItem('companies', '');
	// localStorage.setItem('districts', '');
	// localStorage.setItem('subDistricts', '');
	// localStorage.setItem('services', '');
	// localStorage.setItem('timeSlots', '');
	// localStorage.setItem('paymentMethods', '');
	// localStorage.setItem('addressTypes', '');

	return false;
}

export class Routes extends React.Component {
	componentWillMount() {
		GA.init();
	}

	render() {
		return (
			<Switch>
				{
					routes.map(({
						loginRequired, path, exact, layoutClass, Layout, Component
					}) => {
						if (loginRequired) {
							return (<PrivateRoute key={0} path={path} exact={exact} component={Component} layoutClass={layoutClass} layout={Layout} />);
						}
						return (
							<Route
								key={0}
								path={path}
								exact={exact}
								render={props => (
									<Layout containerClass={layoutClass}>
										<Component {...props} />
									</Layout>
								)}
							/>
						);
					})
				}
			</Switch>
		);
	}
}


export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js